import { I18nComponente } from "@/types/gerais"

export const MTextoAssincronoi18n: I18nComponente = {
  "pt-BR": {
    chaveNaoEncontrada: "chave não encontrada"
  },
  "es-CO": {
    chaveNaoEncontrada: "clave no encontrada"
  },
}
